import { getDashboardLanguage } from "i18n/dashboardLanguage";

export const EnglishCopy = {
  login: {},
  form: {
    loginForm: {
      emailTitle: "Email",
      emailPlaceholder: "Enter your email address",
      passwordTitle: "Password",
      passwordPlaceholder: "Enter your password",
      submitButtonText: "Login",
    },
  },
  sideBar: { logoutText: "Logout", titleText: "Management" },
  stat: {
    todayTitleText: "Today's Statistics",
    todayText: "Today",
    statusText: "Status",
    allTimeText: "All Time",
    assignedText: "Total Assigned",
    soldText: "Total Sold",
    rentText: "Total Rent",
    cancelledText: "Total Cancelled",
    postText: "Total Posts",
    sellPostText: "Total Sale Posts",
    rentPostText: "Total Rent Posts",
    messageText: "Total Messages",
    callsText: "Total Calls",
    usersText: "Total Users",
  },
  overview: {
    searchPlaceholder: "Search live cars...",
    liveCarTitle: "Live Car Status",
    carNoText: "Car no.",
    assignedText: "Assigned",
    statusText: "Status",
    CustomerText: "Customer",
    detailsText: "Details",
    unassignedText: "Unassigned",
    liveText: "Live",
    refreshingText: "Refreshing",
  },
  carScreens: { searchPlaceholder: "Search cars..." },
  carScreen: {
    ModelText: "Model",
    yearText: "Year of Manufacture",
    yearPlaceholder: "Min 2015",
    price: "Price",
    brTag: "Br",
    mileage: "Mileage, km",
    mileagePlaceholderMin: "Min 500",
    mileagePlaceholderMax: "Max 13000",
    transmissionTypeText: "Transmission Type",
    fuelTypeText: "Fuel Type",
    usageTypeText: "Usage Type",
    listingTypeText: "Listing Type",
    description: "Description",
    orderedByText: "Ordered By",
    nameText: "Full Name",
    phoneText: "Phone Number",
    statusText: "Status",
    assignedAgentText: "Assigned Agent",
    carOwnerPhoneText: "Car Owner Phone Number",
    postedByText: "Posted by",
    idText: "ID",
    updateButtonText: "Update",
    imageEditorTitleText: "Listing images",
    imageEditorNoteText:
      "Use Set primary to move an image to the first position before saving. The first image powers car cards and share previews.",
    imageEditorCountText: "images",
    primaryImageText: "Primary image",
    setPrimaryText: "Set primary",
    removeImageText: "Remove",
    minimumImagesErrorText: "A listing must keep at least 4 images.",
  },
  carCard: {
    postedByText: "Posted by",
    carOwnerText: "Car owner",
    statusText: "Status",
  },
  reportsPage: {
    reportedTitle: "Reported Posts",
    reportStatusTitle: "Report Status",
    carNoText: "Car no.",
    reporterText: "Reporter",
    reportedText: "Reported",
    detailsButtonText: "Details",
    modelText: "Model",
    customerText: "Customer",
    dateText: "Date",
    callStatusText: "Call Status",
  },
  messagesPage: {
    title: "Messages",
    messagesTitle: "All Messages",
    messagesSearchPlaceholder: "Search messages...",
    messagePlaceholder: "Type a message...",
  },
  usersPage: {
    titleText: "User List",
    phoneText: "Phone no.",
    nameText: "Full name",
    emailText: "Email address",
    statusText: "Status",
    searchPlaceholder: "Search users...",
  },
  staffPage: {
    titleText: "Staff List",
    phoneText: "Phone no.",
    nameText: "Full name",
    emailText: "Email address",
    statusText: "Status",
    searchPlaceholder: "Search staff...",
  },
  userPage: {
    titleText: "User details",
    postedCarsText: "Posted cars",
    permanentText: "Permanent",
    idText: "ID",
    suspendButtonText: "Suspend User",
    unSuspendButtonText: "Unsuspend User",
    messageButtonText: "Message",
    messageComposerTitleText: "Send direct message",
    messageComposerNoteText:
      "This opens or creates the conversation for the selected user.",
    messageComposerPlaceholderText: "Type a message...",
    messageComposerSendText: "Send message",
    messageComposerCancelText: "Cancel",
    messageComposerOpenThreadText: "Open thread",
    messageComposerSuccessText: "Message sent successfully",
  },
  oneStaffPage: {
    titleText: "Staff details",
    listTitle: "Activities",
    suspendButtonText: "Suspend Staff",
    unSuspendButtonText: "Unsuspend Staff",
    updateStaffText: "Update Staff",
    carNoText: "Car no.",
    assignedText: "Assigned",
    statusText: "Status",
    CustomerText: "Customer",
  },
  createStaffPage: {
    titleText: "Register staff",
    namePlaceholder: "Full name",
    emailPlaceholder: "Email address",
    phonePlaceholder: "Phone number",
    passwordPlaceholder: "Password",
    registerButtonText: "Register",
  },
};

export const AmharicCopy = {
  login: {},
  form: {
    loginForm: {
      emailTitle: "ኢሜይል",
      emailPlaceholder: "ኢሜይልዎን ያስገቡ",
      passwordTitle: "የይለፍ ቃል",
      passwordPlaceholder: "የይለፍ ቃልዎን ያስገቡ",
      submitButtonText: "ግባ",
    },
  },
  sideBar: { logoutText: "ውጣ", titleText: "አስተዳደር" },
  stat: {
    todayTitleText: "የዛሬ ስታቲስቲክስ",
    todayText: "ዛሬ",
    statusText: "ሁኔታ",
    allTimeText: "አጠቃላይ",
    assignedText: "የተመደቡ",
    soldText: "የተሸጡ",
    rentText: "የተከራዩ",
    cancelledText: "የተሰረዙ",
    postText: "ጠቅላላ ማስታወቂያ",
    sellPostText: "የሽያጭ ማስታወቂያ",
    rentPostText: "የኪራይ ማስታወቂያ",
    messageText: "ጠቅላላ መልእክቶች",
    callsText: "ጠቅላላ ጥሪዎች",
    usersText: "ጠቅላላ ተጠቃሚዎች",
  },
  overview: {
    searchPlaceholder: "የቀጥታ መኪናዎችን ይፈልጉ...",
    liveCarTitle: "የቀጥታ መኪና ሁኔታ",
    carNoText: "የመኪና ቁጥር",
    assignedText: "የተመደበለት",
    statusText: "ሁኔታ",
    CustomerText: "ደንበኛ",
    detailsText: "ዝርዝር",
    unassignedText: "አልተመደበም",
    liveText: "ቀጥታ",
    refreshingText: "በማደስ ላይ",
  },
  carScreens: { searchPlaceholder: "መኪና ይፈልጉ..." },
  carScreen: {
    ModelText: "ሞዴል",
    yearText: "የምርት ዓመት",
    yearPlaceholder: "ቢያንስ 2015",
    price: "ዋጋ",
    brTag: "ብር",
    mileage: "የተጓዘው ኪ.ሜ.",
    mileagePlaceholderMin: "ቢያንስ 500",
    mileagePlaceholderMax: "ከፍተኛ 13000",
    transmissionTypeText: "የማርሽ ዓይነት",
    fuelTypeText: "የነዳጅ ዓይነት",
    usageTypeText: "የአጠቃቀም ዓይነት",
    listingTypeText: "የማስታወቂያ ዓይነት",
    description: "መግለጫ",
    orderedByText: "ያዘዘው",
    nameText: "ሙሉ ስም",
    phoneText: "ስልክ ቁጥር",
    statusText: "ሁኔታ",
    assignedAgentText: "የተመደበ ሰራተኛ",
    carOwnerPhoneText: "የመኪና ባለቤት ስልክ",
    postedByText: "የለጠፈው",
    idText: "መለያ",
    updateButtonText: "አዘምን",
    imageEditorTitleText: "የማስታወቂያ ፎቶዎች",
    imageEditorNoteText:
      "ዋና ፎቶ ለመምረጥ ‘ዋና አድርግ’ን ይጫኑ። የመጀመሪያው ፎቶ በካርድና በማጋራት ላይ ይታያል።",
    imageEditorCountText: "ፎቶዎች",
    primaryImageText: "ዋና ፎቶ",
    setPrimaryText: "ዋና አድርግ",
    removeImageText: "አስወግድ",
    minimumImagesErrorText: "ማስታወቂያው ቢያንስ 4 ፎቶዎች ሊኖሩት ይገባል።",
  },
  carCard: {
    postedByText: "የለጠፈው",
    carOwnerText: "የመኪና ባለቤት",
    statusText: "ሁኔታ",
  },
  reportsPage: {
    reportedTitle: "ሪፖርት የተደረጉ ማስታወቂያዎች",
    reportStatusTitle: "የሪፖርት ሁኔታ",
    carNoText: "የመኪና ቁጥር",
    reporterText: "ሪፖርት ያደረገው",
    reportedText: "ሪፖርት የተደረገበት",
    detailsButtonText: "ዝርዝር",
    modelText: "ሞዴል",
    customerText: "ደንበኛ",
    dateText: "ቀን",
    callStatusText: "የጥሪ ሁኔታ",
  },
  messagesPage: {
    title: "መልእክቶች",
    messagesTitle: "ሁሉም መልእክቶች",
    messagesSearchPlaceholder: "መልእክት ይፈልጉ...",
    messagePlaceholder: "መልእክት ይጻፉ...",
  },
  usersPage: {
    titleText: "የተጠቃሚዎች ዝርዝር",
    phoneText: "ስልክ ቁጥር",
    nameText: "ሙሉ ስም",
    emailText: "ኢሜይል",
    statusText: "ሁኔታ",
    searchPlaceholder: "ተጠቃሚ ይፈልጉ...",
  },
  staffPage: {
    titleText: "የሰራተኞች ዝርዝር",
    phoneText: "ስልክ ቁጥር",
    nameText: "ሙሉ ስም",
    emailText: "ኢሜይል",
    statusText: "ሁኔታ",
    searchPlaceholder: "ሰራተኛ ይፈልጉ...",
  },
  userPage: {
    titleText: "የተጠቃሚ ዝርዝር",
    postedCarsText: "የለጠፋቸው መኪናዎች",
    permanentText: "ቋሚ",
    idText: "መለያ",
    suspendButtonText: "ተጠቃሚውን አግድ",
    unSuspendButtonText: "እገዳውን አንሳ",
    messageButtonText: "መልእክት",
    messageComposerTitleText: "ቀጥታ መልእክት ላክ",
    messageComposerNoteText: "ለተመረጠው ተጠቃሚ ውይይት ይከፍታል ወይም ይፈጥራል።",
    messageComposerPlaceholderText: "መልእክት ይጻፉ...",
    messageComposerSendText: "መልእክት ላክ",
    messageComposerCancelText: "ይቅር",
    messageComposerOpenThreadText: "ውይይቱን ክፈት",
    messageComposerSuccessText: "መልእክቱ ተልኳል",
  },
  oneStaffPage: {
    titleText: "የሰራተኛ ዝርዝር",
    listTitle: "እንቅስቃሴዎች",
    suspendButtonText: "ሰራተኛውን አግድ",
    unSuspendButtonText: "እገዳውን አንሳ",
    updateStaffText: "ሰራተኛ አዘምን",
    carNoText: "የመኪና ቁጥር",
    assignedText: "የተመደበ",
    statusText: "ሁኔታ",
    CustomerText: "ደንበኛ",
  },
  createStaffPage: {
    titleText: "ሰራተኛ መዝግብ",
    namePlaceholder: "ሙሉ ስም",
    emailPlaceholder: "ኢሜይል",
    phonePlaceholder: "ስልክ ቁጥር",
    passwordPlaceholder: "የይለፍ ቃል",
    registerButtonText: "መዝግብ",
  },
};

const AppCopy =
  getDashboardLanguage() === "am" ? AmharicCopy : EnglishCopy;

export default AppCopy;
